import api from '../api/client'

const isencaoDefesaConfigService = {
  getConfig: async (organizadorId) => {
    const response = await api.get(`/configuracoes/isencao-defesa/organizadores/${organizadorId}/isencao-defesa-config`)
    return response.data
  },

  saveConfig: async (organizadorId, config) => {
    const response = await api.put(`/configuracoes/isencao-defesa/organizadores/${organizadorId}/isencao-defesa-config`, config)
    return response.data
  },
}

export default isencaoDefesaConfigService
